export default "__VITE_ASSET__e9882376__"